import { FC, useState } from 'react'
import { ReactComponent as AddCoinIcon } from '@/assets/icons/addCoin2.svg'
import styles from './index.module.scss'
import { Input, Button, List, Switch } from 'antd'
import CoinLogo from '../CoinLogo'
import Modal from '@/components/Modal'
import i18n from '@/services/i18n'
import { WalletCoin } from '@/services/apis/coin/models'
import { useTranslation } from '@/services/i18n'
import { useGetWalletCoinList, useSearchWalletCoinList, useChangeCoinSwitch } from '@/hooks/coin'

const { Search } = Input

interface CoinItemProps {
  walletKey: string
  data: WalletCoin
}

const CoinItem: FC<CoinItemProps> = ({ walletKey, data }) => {
  const { loading, checked, onToggle } = useChangeCoinSwitch(
    walletKey,
    data.coinKey,
    data.showStatus === 1
  )
  return (
    <List.Item
      actions={[<Switch onChange={onToggle} loading={loading} checked={checked} />]}
      className={styles.listItem}
    >
      <div className={styles.coinNameWrapper}>
        <CoinLogo logo={data.logoUrl} networkLogo={data.networkLogo} />
        <div className={styles.coinName}>{`${data.coinName} (${data.coinFullName})`}</div>
      </div>
    </List.Item>
  )
}

interface CoinListProps {
  walletKey: string
}

const CoinList: FC<CoinListProps> = ({ walletKey }) => {
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState('')
  const { data, isLoading } = useGetWalletCoinList(walletKey)
  const searchedCoins = useSearchWalletCoinList(searchValue.trim(), data)
  return (
    <div className={styles.list}>
      <Search
        placeholder={t('wallet.detail.coinSearch') || ''}
        enterButton={<Button type="primary">{t('common.search')}</Button>}
        style={{ width: 450, paddingBottom: 8 }}
        onSearch={setSearchValue}
      />
      <div className={styles.coins}>
        <List
          loading={isLoading}
          dataSource={searchedCoins}
          rowKey={item => item.coinKey}
          renderItem={item => <CoinItem walletKey={walletKey} data={item} />}
        />
      </div>
    </div>
  )
}

const open = (walletKey: string) => {
  Modal.info({
    content: <CoinList walletKey={walletKey} />,
    icon: <AddCoinIcon />,
    title: i18n.t('wallet.detail.coinManage'),
    footer: null,
    closable: true,
  })
}

export default {
  open,
}
